import React from 'react';

import { Button } from '@mantine/core';
import config from 'config';
import { useAuth } from 'context/auth-context';
import useCreateGLMOAuthState from 'hooks/glmLink/useCreateGLMOAuthState';

export default function ConnectHighLevelButton(): JSX.Element {
  const { session } = useAuth();
  const ghlV2Enabled = session?.gym?.ghlV2Enabled;
  const { mutateAsync: createGLMOAuthState } = useCreateGLMOAuthState();
  const onClick: () => Promise<void> = async () => {
    try {
      const clientId = config.GHLCLIENTID || process.env.GHLCLIENTID;
      const redirectUri = `${config.API_SERVER}/glm-oauth/` || `${process.env.APISERVER}/glm-oauth/`;
      const { data } = await createGLMOAuthState();
      const state = encodeURIComponent(data.state);
      const versionId = config.GHLVERSIONID || process.env.GHLVERSIONID;
      const scope =
        'contacts.readonly+contacts.write+locations%2Ftags.readonly+locations%2Ftags.write+locations.readonly+opportunities.readonly+opportunities.write+locations%2FcustomFields.readonly+locations%2FcustomFields.write';
      const url = `https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${encodeURIComponent(
        redirectUri,
      )}&client_id=${clientId}&scope=${scope}&version_id=${versionId}&state=${state}`;
      window.location.href = url;
    } catch (error) {
      alert('Failed to connect to Gym Lead Machine. Please try again later.');
    }
  };

  return ghlV2Enabled ? (
    <Button sx={{ backgroundColor: 'green' }} onClick={onClick}>
      Reconnect to Gym Lead Machine
    </Button>
  ) : (
    <Button onClick={onClick}>Connect to Gym Lead Machine</Button>
  );
}
